export default {
      id: "docs-usage",
      viewBox: "0 0 27 27",
      url: __webpack_public_path__ + "sprite.svg#docs",
      toString: function () {
        return this.url;
      }
    }